<mc-loading [overlay]="true" *ngIf="loading"></mc-loading>
<div class="container-allModal position-relative">
    <div class="row d-flex align-items-center container-title pb-0 pb-sm-3 mb-2 mb-sm-4 position-relative">
        <p class="col-12 col-xl-2 design-modal-title bold uppercase-text mb-3 mb-xl-0" *ngIf="!isFileUpload">
            {{ 'app.global.modals.image_manager.title' | translate }}
        </p>

        <p class="col-12 col-xl-2 design-modal-title bold uppercase-text mb-3 mb-xl-0" *ngIf="isFileUpload">
            {{ 'app.global.modals.image_manager.file_title' | translate }}
        </p>
        <div class="col-12 col-sm-4 col-xl-3 px-2 mb-3 mb-xl-0">
            <form [formGroup]="searchForm" *ngIf="searchForm">
                <div class="position-relative">
                    <input class="form-control" id="searchValue" name="searchValue" form="searchForm"
                        formControlName="searchValue" type="search"
                        placeholder="{{ 'app.global.modals.image_manager.filters.search' | translate }}" />
                    <i class="fal fa-search mr-2 icon-search-input"></i>
                </div>
            </form>
        </div>
        <div class="col-12 col-sm-4 col-xl-3 px-2 mb-3 mb-xl-0">
            <div class="img-filter">
                <form [formGroup]="searchForm" *ngIf="searchForm">
                    <div class="position-relative">
                        <select class="form-control w-100" id="filter_img"
                            (change)="setFilters($event, filtertType.MODULE)" formControlName="module">
                            <ng-container *ngFor="let option of modulesOptions; let i = index">
                                <option [value]="option.id">
                                    {{ option.name }}
                                </option>
                            </ng-container>
                        </select>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-12 col-sm-4 col-xl-2 px-2 mb-3 mb-xl-0">
            <div class="order-filter">
                <form [formGroup]="searchForm" *ngIf="searchForm">
                    <div class="position-relative">
                        <select class="form-control w-100" id="filter_order"
                            (change)="setFilters($event, filtertType.PRIORITY)" formControlName="priority">
                            <ng-container *ngFor="let option of priorityOptions; let i = index">
                                <option [value]="option.id">
                                    {{ option.name }}
                                </option>
                            </ng-container>
                        </select>
                    </div>
                </form>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-end col-12 col-xl-2 px-2 container-icons">
            <div class="icons">
                <i class="fa-regular fa-upload btn-upImg" (click)="openUploadDialog()" *ngIf="!isFileUpload"></i>
                <i class="fa-regular fa-upload btn-upImg" (click)="openFileUploadWindow(fileUpload)"
                    *ngIf="isFileUpload"></i>
                <i class="fa fa-regular fa-list ml-3" (click)="toggleView()"></i>
                <ng-container *ngIf="!isFileUpload">
                    <i class="fa fa-regular fa-gear ml-3" [matMenuTriggerFor]="menu"></i>
                    <mat-menu #menu="matMenu">
                        <form [formGroup]="optimizationForm" *ngIf="(optimizationConfig$ | async) != null">
                            <div class="p-2">
                                <label class="form-check-label">
                                    <small>{{
                                        'app.global.modals.image_manager.config.optimization.title' | translate
                                        }}</small>
                                    <ss-checkbox name="status" type="checkbox" checkboxLabel="{{
                                            'app.global.modals.image_manager.config.optimization.switch_label' | translate
                                        }}" [form]="optimizationForm"></ss-checkbox>
                                </label>
                            </div>
                        </form>
                    </mat-menu>
                </ng-container>
            </div>
        </div>
    </div>
    <div *ngIf="selectedFiles?.size"
        class="w-100 d-flex justify-content-between align-items-center container-title pb-2 pb-sm-3">
        <div class="d-flex align-items-center">
            <i class="fa fa-regular fa-xmark mr-3 icon-delete" (click)="resetSelection()"></i>
            <ng-container *ngIf="!isFileUpload">
                <ng-container *ngIf="selectedFiles?.size === 1; else multipleImages">
                    <p class="mb-0 text-delete">
                        {{ selectedFiles?.size }} {{ 'app.global.modals.image_manager.buttons.selected_image' | translate }}
                    </p>
                </ng-container>
                <ng-template #multipleImages>
                    <p class="mb-0 text-delete">
                        {{ selectedFiles?.size }}
                        {{ 'app.global.modals.image_manager.buttons.selected_images' | translate }}
                    </p>
                </ng-template>
            </ng-container>

            <ng-container *ngIf="isFileUpload">
                <ng-container *ngIf="selectedFiles?.size === 1; else multipleFiles">
                    <p class="mb-0 text-delete">
                        {{ selectedFiles?.size }} {{ 'app.global.modals.image_manager.buttons.selected_file' | translate }}
                    </p>
                </ng-container>
                <ng-template #multipleFiles>
                    <p class="mb-0 text-delete">
                        {{ selectedFiles?.size }}
                        {{ 'app.global.modals.image_manager.buttons.selected_files' | translate }}
                    </p>
                </ng-template>
            </ng-container>
        </div>
        <i class="fa fa-regular fa-trash ml-3 btn-deleteImg" *ngIf="(imageList$ | async)?.length && !filtering && !isFileUpload"
            [disabled]="!selectedFiles?.size || loading" (click)="deletePhotos()">
        </i>
        <i class="fa fa-regular fa-trash ml-3 btn-deleteImg" *ngIf="(fileList$ | async)?.length && !filtering && isFileUpload"
            [disabled]="!selectedFiles?.size || loading" (click)="deletePhotos()">
        </i>
    </div>

    <!-- VISTA IMAGENES -->
    <ng-container *ngIf="(imageList$ | async)?.length && !filtering">
        <!-- Grid View -->
        <div *ngIf="viewMode === 'grid' && !isFileUpload"
            class="container-box mt-4 d-flex flex-wrap justify-content-center justify-content-lg-start p-2">
            <ng-container *ngFor="let image of imageList$ | async; let i = index">
                <div class="img-container position-relative mr-3 mb-3" [class.checked]="isSelected(image)"
                    (click)="toggleFileSelection(image)">
                    <img class="w-100" [src]="getThumb(image.url)" [alt]="image.filename"
                        (error)="setDefaultUrl($event, image.url, image.id)" />
                    <p class="description pr-3 pr-sm-2">{{ image.filename }}</p>
                    <div class="d-flex icons-img">
                        <i class="fa-light fa-edit" (click)="cropImage(i); $event.stopPropagation()"></i>
                        <i class="fa-light fa-trash ml-2" (click)="deleteOnePhoto(image); $event.stopPropagation()"></i>
                        <i class="fa-light fa-magnifying-glass ml-2"
                            (click)="openCarouselModal(i); $event.stopPropagation()"></i>
                    </div>
                    <input type="checkbox" [checked]="isSelected(image)" />
                </div>
            </ng-container>
        </div>

        <!-- List view -->
        <div *ngIf="viewMode === 'list' && !isFileUpload" class="container-box mt-4 d-flex flex-column p-2">
            <div class="d-flex justify-content-between align-items-center img-container-list position-relative mr-3 mb-2 px-3 py-2 data-image-container rounded"
                [class.checked]="isSelected(image)">
                <p class="mb-0 title-list">Nombre</p>
                <p class="mb-0 title-list">Acciones</p>
            </div>
            <ng-container *ngFor="let image of imageList$ | async; let i = index">
                <div class="d-flex justify-content-between align-items-center img-container-list position-relative mr-3 mb-2 px-3 py-2 data-image-container rounded"
                    [class.checked]="isSelected(image)" (click)="toggleFileSelection(image)"
                    [ngClass]="{ 'no-image-action': singleSelection && selectedFiles.size === 1 }">
                    <div class="d-flex align-items-center">
                        <input class="check-list-view" type="checkbox" [checked]="isSelected(image)" />
                        <img class="w-100 mx-2 d-none d-sm-block" [src]="getThumb(image.url)" [alt]="image.filename"
                            (error)="setDefaultUrl($event, image.url, image.id)" />
                        <p class="description mb-0 mx-2 mx-sm-0">{{ image.filename }}</p>
                    </div>
                    <div class="d-flex icons-img align-items-center">
                        <i class="fa-light fa-edit" (click)="cropImage(i); $event.stopPropagation()"></i>
                        <i class="fa-light fa-trash ml-2" (click)="deleteOnePhoto(image); $event.stopPropagation()"></i>
                        <i class="fa-light fa-magnifying-glass ml-2"
                            (click)="openCarouselModal(i); $event.stopPropagation()"></i>
                    </div>
                </div>
            </ng-container>
        </div>

        <div *ngIf="(imageList$ | async)?.length > 0 && !filtering && !(showEmptyState$ | async)"
            class="paginator-images-manager">
            <mat-paginator (page)="handlePageEvent($event)" [length]="imagesPaginator.length"
                [pageSize]="imagesPaginator.pageSize" [pageSizeOptions]="pageSizeOptions"
                [pageIndex]="imagesPaginator.pageIndex" aria-label="Select page">
            </mat-paginator>
        </div>
    </ng-container>

    <!-- VISTA ARCHIVOS -->
    <ng-container *ngIf="(fileList$ | async)?.length && !filtering">
        <!-- Chips de filtro por tipo de archivo -->
        <div class="file-type-chips-container mb-3" *ngIf="isFileUpload">
            <mat-chip-list>
                <mat-chip
                    *ngFor="let chip of fileTypeChips"
                    class="mat-chip-file-filter"
                    [selected]="selectedChipId === chip.id"
                    (click)="selectFileTypeChip(chip.id)"
                >
                    {{ chip.label }}
                </mat-chip>
            </mat-chip-list>
        </div>
         <!-- Grid View -->
        <div *ngIf="viewMode === 'grid' && isFileUpload"
            class="container-box mt-4 d-flex flex-wrap justify-content-center justify-content-lg-start p-2">
            <ng-container *ngFor="let file of fileList$ | async; let i = index">
                <div class="file-card position-relative mr-3 mb-3" [class.checked]="isSelected(file)"
                    (click)="toggleFileSelection(file)">
                    <input type="checkbox" [checked]="isSelected(file)" class="file-checkbox" />
                    <div class="file-header ml-4">
                        <div class="file-header-left">
                            <i class="file-icon-small" [ngClass]="[getFileIcon(file.filename), getFileIconColorClass(file.filename)]"></i>
                            <p class="file-name">{{ file.filename }}</p>
                        </div>
                        <i
                            mat-icon-button
                            [matMenuTriggerFor]="fileMenu"
                            #menuTrigger="matMenuTrigger"
                            (mouseenter)="mouseEnter(menuTrigger)"
                            (mouseleave)="mouseLeave(menuTrigger)"
                            class="fal fa-ellipsis-v-alt px-1 px-xl-2"
                        >
                        </i>
                    </div>
                    <div class="file-icon-container">
                        <i class="file-icon-large file-card-icon" [ngClass]="[getFileIcon(file.filename), getFileIconColorClass(file.filename)]"></i>
                    </div>
                </div>
                <mat-menu #fileMenu="matMenu" [hasBackdrop]="false" xPosition="after">
                    <div (mouseenter)="mouseEnter(menuTrigger)" (mouseleave)="mouseLeave(menuTrigger)">
                        <button
                            class="creation-menu-item"
                            (click)="copyToClipboard($event, file.url)"
                            mat-menu-item
                        >
                            <span class="new-element">{{ 'app.global.modals.image_manager.file_actions.copy_url' | translate }} </span>
                        </button>
                        <button
                            class="creation-menu-item"
                            (click)="downloadFile(file)"
                            mat-menu-item
                        >
                            <span class="new-element">{{ 'app.global.modals.image_manager.file_actions.download' | translate }} </span>
                        </button>
                        <button
                            class="creation-menu-item"
                            (click)="deleteOneFile(file)"
                            mat-menu-item
                        >
                            <span class="new-element">{{ 'app.global.modals.image_manager.file_actions.delete' | translate }} </span>
                        </button>
                    </div>
                </mat-menu>
            </ng-container>
        </div>

        <!-- List view -->
        <div *ngIf="viewMode === 'list' && isFileUpload" class="container-box mt-4 d-flex flex-column p-2">
            <div class="d-flex justify-content-between align-items-center img-container-list position-relative mr-3 mb-2 px-3 py-2 data-image-container rounded"
                [class.checked]="isSelected(file)">
                <p class="mb-0 title-list">Nombre</p>
                <p class="mb-0 title-list">Acciones</p>
            </div>
            <ng-container *ngFor="let file of fileList$ | async; let i = index">
                <div class="d-flex justify-content-between align-items-center img-container-list position-relative mr-3 mb-2 px-3 py-2 data-image-container rounded"
                    [class.checked]="isSelected(file)" (click)="toggleFileSelection(file)"
                    [ngClass]="{ 'no-image-action': singleSelection && selectedFiles.size === 1 }">
                    <div class="d-flex align-items-center">
                        <input class="check-list-view" type="checkbox" [checked]="isSelected(file)" />
                        <div class="file-icon-container">
                            <i class="file-icon-small ml-2 mr-2" [ngClass]="[getFileIcon(file.filename), getFileIconColorClass(file.filename)]"></i>
                        </div>
                        <p class="description mb-0 mx-2 mx-sm-0">{{ file.filename }}</p>
                    </div>
                    <i
                        mat-icon-button
                        [matMenuTriggerFor]="fileMenu"
                        #menuTrigger="matMenuTrigger"
                        (mouseenter)="mouseEnter(menuTrigger)"
                        (mouseleave)="mouseLeave(menuTrigger)"
                        class="fal fa-ellipsis-v-alt px-1 px-xl-2"
                    >
                    </i>
                    <mat-menu #fileMenu="matMenu" [hasBackdrop]="false" xPosition="after">
                        <div (mouseenter)="mouseEnter(menuTrigger)" (mouseleave)="mouseLeave(menuTrigger)">
                            <button
                                class="creation-menu-item"
                                (click)="copyToClipboard($event, file.url)"
                                mat-menu-item
                            >
                                <span class="new-element">{{ 'app.global.modals.image_manager.file_actions.copy_url' | translate }} </span>
                            </button>
                            <button
                                class="creation-menu-item"
                                (click)="downloadFile(file)"
                                mat-menu-item
                            >
                                <span class="new-element">{{ 'app.global.modals.image_manager.file_actions.download' | translate }} </span>
                            </button>
                            <button
                                class="creation-menu-item"
                                (click)="deleteOneFile(file)"
                                mat-menu-item
                            >
                                <span class="new-element">{{ 'app.global.modals.image_manager.file_actions.delete' | translate }} </span>
                            </button>
                        </div>
                    </mat-menu>
                </div>
            </ng-container>
        </div>

        <div *ngIf="(fileList$ | async)?.length > 0 && !filtering && !(showEmptyState$ | async)"
            class="paginator-images-manager">
            <mat-paginator (page)="handlePageEvent($event)" [length]="filesPaginator.length"
                [pageSize]="filesPaginator.pageSize" [pageSizeOptions]="pageSizeOptions"
                [pageIndex]="filesPaginator.pageIndex" aria-label="Select page">
            </mat-paginator>
        </div>
    </ng-container>

    <ng-container>
        <div *ngIf="filtering" class="position-absolute-search">
            <!-- <mc-loading [overlay]="true"></mc-loading> -->
            <span class="spinner-border text-primary"></span>
        </div>
        <!-- empty-state para busqueda -->
         <ng-container *ngIf="!isFileUpload">
            <div *ngIf="(imageList$ | async)?.length === 0 && !(showEmptyState$ | async)"
                class="position-absolute-search position-relative mt-0 mb-5 container-empty">
                <div class="text-center">
                    <img [src]="assetsUrl + mfsPath + '/img/front/images/emptySearch.svg'" alt="busqueda_sin_resultados"
                        class="mb-4 w-100 img-empty" />
                    <p class="mb-0">{{ 'app.global.modals.image_manager.no_results.title' | translate }} <br /></p>
                    <p class="btn-clear mt-3" (click)="clearFilters()">
                        {{ 'app.global.modals.image_manager.no_results.clear' | translate }}
                    </p>
                </div>
            </div>
         </ng-container>

         <ng-container *ngIf="isFileUpload">
            <div *ngIf="(fileList$ | async)?.length === 0 && !(showEmptyState$ | async)"
                class="position-absolute-search position-relative mt-0 mb-5 container-empty">
                <div class="text-center">
                    <img [src]="assetsUrl + mfsPath + '/img/front/images/emptySearch.svg'" alt="busqueda_sin_resultados"
                        class="mb-4 w-100 img-empty" />
                    <p class="mb-0">{{ 'app.global.modals.image_manager.no_results.title_file' | translate }} <br /></p>
                    <p class="btn-clear mt-3" (click)="clearFilters()">
                        {{ 'app.global.modals.image_manager.no_results.clear' | translate }}
                    </p>
                </div>
            </div>
         </ng-container>

        <!-- empty-state sin datos -->
        <ng-container *ngIf="!isFileUpload">
            <div *ngIf="(showEmptyState$ | async) && !loading"
                class="position-absolute-search position-relative mt-0 mb-5 container-empty">
                <div class="text-center">
                    <img [src]="assetsUrl + mfsPath + emptyStateImg" alt=""
                        class="mb-4 w-100 img-empty" />
                    <p class="mb-0">
                        {{ 'app.global.modals.image_manager.empty_state.message' | translate }} <br />
                        {{ 'app.global.modals.image_manager.empty_state.start' | translate }} <br />
                        <a class="color-link link-upImg" (click)="openUploadDialog()">
                            {{ 'app.global.modals.image_manager.empty_state.upload_image' | translate }}
                        </a>
                    </p>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="isFileUpload">
            <div *ngIf="(showEmptyState$ | async) && !loading"
                class="position-absolute-search position-relative mt-0 mb-5 container-empty">
                <div class="text-center">
                    <img [src]="assetsUrl + mfsPath + emptyStateFile" alt=""
                        class="mb-4 w-100 img-empty" />

                    <p class="mb-0">
                        {{ 'app.global.modals.image_manager.empty_state_file.message' | translate }} <br />
                        {{ 'app.global.modals.image_manager.empty_state_file.start' | translate }} <br />
                        <a class="color-link link-upImg" (click)="openFileUploadWindow(fileUpload)">
                            {{ 'app.global.modals.image_manager.empty_state_file.upload_file' | translate }}
                        </a>
                    </p>
                </div>
            </div>           
        </ng-container>
    </ng-container>

    <div class="d-flex justify-content-end mt-3 mt-lg-4 buttons-modal">
        <div class="storage-container d-flex align-items-center mr-auto" *ngIf="isFileUpload">
            <div class="flex-grow-1">
                <div class="d-flex flex-column justify-content-between align-items-start">
                    <div>
                        <i class="fa fa-cloud mr-2"></i>
                        <small>Almacenamiento ({{ sizeStatus.usedPercentage | number:'1.2-2' }}% usado)</small>
                    </div>
                    <div><small>{{ sizeStatus.usedMB }}MB de {{ sizeStatus.maxGB }}GB utilizado(s)</small></div>
                </div>

                <mat-progress-bar class="mt-1" [ngClass]="progressBarClass" [color]="progressColor" mode="determinate" [value]="sizeStatus.usedPercentage">
                </mat-progress-bar>
            </div>
        </div>
        <div class="d-flex align-items-center">
            <button class="btn btn-skip mr-3 mr-sm-4" tabindex="0" (click)="closeDialog()">
                {{ 'app.global.modals.image_manager.buttons.cancel' | translate }}
            </button>
            <button *ngIf="!isFileUpload" class="btn btn-continue" type="submit" tabindex="0" (click)="sendData()"
                [disabled]="selectedFiles.size === 0">
                {{ 'app.global.modals.image_manager.buttons.add_image' | translate }}
            </button>
            <button *ngIf="isFileUpload" class="btn btn-continue" type="submit" tabindex="0" (click)="sendData()"
                [disabled]="selectedFiles.size === 0">
                {{ 'app.global.modals.image_manager.buttons.add_file' | translate }}
            </button>
        </div>
    </div>
</div>

<input type="file" class="d-none" (change)="fileBrowseHandler($event)" #fileUpload multiple
    [accept]="acceptedFileTypes.join(',')" (click)="$event.target.value = null" />